export const statusConfig = {
  active: { bg: "#ECFDF3", color: "#027A48", label: "Active" },
  inactive: { bg: "#FFDCE2", color: "#F94765", label: "Inactive" },
  pending: { bg: "#FEF6D7", color: "#FED229", label: "Pending" },
  suspended: { bg: "#FFF2F0", color: "#E2341D", label: "Suspended" },
  terminated: { bg: "#FFDCE2", color: "#F94765", label: "Terminated" },
};

export const bookingStatusConfig = {
  booked: { bg: "#FEF6D7", color: "#FED229", label: "Booked" },
  assigned: { bg: "#D3EAFF", color: "#437EF7", label: "Assigned" },
  out_for_delivery: { bg: "#FFE0CB", color: "#FF8532", label: "Out for Delivery" },
  delivered: { bg: "#ECFDF3", color: "#027A48", label: "Delivered" },
  cancelled: { bg: "#FFDCE2", color: "#F94765", label: "Cancelled" },
  rescheduled: { bg: "#F3F4F6", color: "#1e293b", label: "Rescheduled" },
};

export const orderStatusConfig = {
  pending: { bg: "#FEF6D7", color: "#FED229", label: "Pending" },
  confirmed: { bg: "#D3EAFF", color: "#437EF7", label: "Confirmed" },
  processing: { bg: "#FFE0CB", color: "#FF8532", label: "Processing" },
  shipped: { bg: "#D3EAFF", color: "#437EF7", label: "Shipped" },
  delivered: { bg: "#ECFDF3", color: "#027A48", label: "Delivered" },
  cancelled: { bg: "#FFDCE2", color: "#F94765", label: "Cancelled" },
};

export const invoiceStatusConfig = {
  paid: { bg: "#ECFDF3", color: "#027A48", label: "Paid" },
  unpaid: { bg: "#FFDCE2", color: "#F94765", label: "Unpaid" },
  partial: { bg: "#FEF6D7", color: "#FED229", label: "Partial" },
  overdue: { bg: "#FFF2F0", color: "#E2341D", label: "Overdue" },
};

export const customerTypeConfig = {
  premium: { bg: "#D3EAFF", color: "#437EF7", label: "Premium" },
  wholesale: { bg: "#FFE0CB", color: "#FF8532", label: "Wholesale" },
  regular: { bg: "#F3F4F6", color: "#1e293b", label: "Regular" },
  corporate: { bg: "#E8F5E9", color: "#2E7D32", label: "Corporate" },
};